import type { Href } from "expo-router";
import { Redirect, useLocalSearchParams } from "expo-router";

/**
 * Catch-all redirect for the retired Manager portal. Every `/manager/<path>`
 * maps 1:1 to the equivalent `/client/<path>` (the per-competition tabs —
 * dashboard, candidates, pipeline, positions, deliverables — and settings all
 * exist under /client). A limited client sees only their assigned data there
 * via RLS. Unknown sub-paths fall back to the Client dashboard.
 */
export default function ManagerCatchAllRedirect() {
  const params = useLocalSearchParams<{ rest?: string | string[] }>();
  const rest = params.rest;
  const segments = Array.isArray(rest) ? rest : rest ? [rest] : [];
  const target = segments.length > 0 ? `/client/${segments.join("/")}` : "/client";
  return <Redirect href={target as Href} />;
}
